<ng-container *ngIf="error$ | async as errorMsg; else resultOrLoadingTpl">
  SAP Gave an error:
  <strong>{{ errorMsg }}</strong>
</ng-container>

<ng-template #resultOrLoadingTpl>
  <nz-spin *ngIf="isLoading$ | async; else result" nzSimple></nz-spin>
</ng-template>

<ng-template #result>
  <ng-container *ngIf="connectors$ | async as connectors; else noConnectors">
    <div *ngFor="let connector of connectors; trackBy: trackByRef">
      <i nz-icon nzType="tag" nzTheme="outline"></i>
      {{ connector.mainConnector }}
    </div>
  </ng-container>

  <ng-template #noConnectors>No connectors</ng-template>
</ng-template>
